/* access-required.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./access-required.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useEffect } from 'react';
import { useIntl } from 'react-intl-next';
import EmptyState from '@atlaskit/empty-state';
import { Box } from '@atlaskit/primitives/compiled';
import { useDatasourceAnalyticsEvents } from '../../../analytics';
import { SpotPadlockKey } from '../../../common/ui/spot/basics/padlock-key';
import { loadingErrorMessages } from './messages';
var styles = {
  iconContainerStyles: "_otyrpxbi",
  descriptionMessageStyles: "_zulppxbi _1e0c1txw _2lx21bp4",
  urlStyles: "_11c8lodh _syazi7uo _19pkmgjw"
};
var Description = function Description(_ref) {
  var message = _ref.message,
    url = _ref.url;
  return /*#__PURE__*/React.createElement("div", {
    className: ax([styles.descriptionMessageStyles])
  }, /*#__PURE__*/React.createElement("span", {
    className: ax([styles.urlStyles])
  }, url), /*#__PURE__*/React.createElement("span", null, message));
};
var IconContainer = function IconContainer() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.iconContainerStyles
  }, /*#__PURE__*/React.createElement(SpotPadlockKey, {
    size: 'xlarge',
    alt: formatMessage(loadingErrorMessages.accessRequired)
  }));
};
export var AccessRequired = function AccessRequired(_ref2) {
  var url = _ref2.url;
  var _useIntl2 = useIntl(),
    formatMessage = _useIntl2.formatMessage;
  var _useDatasourceAnalyti = useDatasourceAnalyticsEvents(),
    fireEvent = _useDatasourceAnalyti.fireEvent;
  useEffect(function () {
    fireEvent('ui.error.shown', {
      reason: 'access'
    });
  }, [fireEvent]);
  if (url) {
    return /*#__PURE__*/React.createElement(EmptyState, {
      testId: "datasource--access-required-with-url",
      header: formatMessage(loadingErrorMessages.accessRequiredWithSite),
      headingLevel: 2,
      description: /*#__PURE__*/React.createElement(Description, {
        message: formatMessage(loadingErrorMessages.accessInstructions),
        url: url
      }),
      renderImage: IconContainer
    });
  }
  return /*#__PURE__*/React.createElement(EmptyState, {
    testId: "datasource--access-required",
    header: formatMessage(loadingErrorMessages.accessRequired),
    description: formatMessage(loadingErrorMessages.accessInstructions),
    renderImage: IconContainer
  });
};